import {
  BitfStrapiFormItemsConfigApiRequestPart,
  BitfStrapiPaginationApiRequestPart,
  BitfStrapiSearchApiRequestPart,
  BitfStrapiSortApiRequestPart,
} from '@common/libs/bitforce/core/api-call-state/bitf-strapi-api-call-state';

import { EApiCallStateNames, EApiRequestPartKeys, EBitfApiSortDirection } from '@enums';
import { IBitfApiCallState } from '@interfaces';
import { DefaultApiCallStateMapper } from './default-api-call-state.mapper';

export const apiCallStateConfig = [
  {
    apiCallStateName: EApiCallStateNames.PROJECTS,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.PROJECTS_SORT_CODE,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.PROJECTS_SORT_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.PROJECTS_SORT_STATUS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.PROJECTS_SORT_END_DATE,
        defaultPartData: {
          data: { property: 'end_date', direction: EBitfApiSortDirection.DESC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.PROJECTS_SORT_TYPOLOGY,
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.PROJECT_TASKS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart({}),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_STATUS,
        defaultPartData: {
          data: { property: 'is_completed', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_END_DATE,
        defaultPartData: {
          data: { property: 'end_date', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_ASSIGNED_TO_COSTUMER,
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.PROJECT_GENERAL_TASKS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart({}),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_STATUS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_END_DATE,
        defaultPartData: {
          data: { property: 'end_date', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_ASSIGNED_TO_COSTUMER,
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.DIARY_TASKS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart({}),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_STATUS,
        defaultPartData: {
          data: { property: 'is_completed', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_END_DATE,
        defaultPartData: {
          data: { property: 'end_date', direction: EBitfApiSortDirection.ASC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.TASKS_SORT_ASSIGNED_TO_COSTUMER,
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.DOCUMENTS,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart({}),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.DOCUMENTS_SORT_NAME,
        defaultPartData: {
          data: { property: 'name', direction: EBitfApiSortDirection.ASC },
        },
      }),
    ],
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.NOTES,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSearchApiRequestPart({}),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.EXPENSE_FILE_ARCHIVE,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 30 },
      }),
      new BitfStrapiFormItemsConfigApiRequestPart(),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_CREATED_AT,
        defaultPartData: {
          data: { property: 'expense_file.createdAt', direction: EBitfApiSortDirection.DESC },
        },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_PROJECT_NAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_PROJECT_END_DATE,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_PROJECT_PROVINCE,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_PROJECT_TYPOLOGY,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_EXPENSE_FILE_STATUS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.EXPENSE_FILE_ARCHIVE_SORT_PROJECT_CUSTOMER_NAME,
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
